module.exports = __webpack_public_path__ + "static/img/dsf_01.a84f926.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dsfRobot/dsf_01.png
// module id = Fblt
// module chunks = 46